import { render, staticRenderFns } from "./wy-autoQA-configuration.vue?vue&type=template&id=f7d6486e&"
import script from "./wy-autoQA-configuration.vue?vue&type=script&lang=js&"
export * from "./wy-autoQA-configuration.vue?vue&type=script&lang=js&"
import style0 from "./wy-autoQA-configuration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports